import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Button, Spin } from 'antd';
import { Modal, Icon } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import { Markup } from 'interweave';
import * as SignalR from '@aspnet/signalr';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const confirmAlert = Modal.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'SingleListStore',
    'loginStore',
    'webSettingStore'
)
@observer
class SingleListMain extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        if (this.props.match.params.menuID !== undefined && this.props.match.params.languageID !== undefined) {
            const menuID = this.props.match.params.menuID;
            const languageID = this.props.match.params.languageID;

            this.props.templateStore.getActive();
            this.props.CmsLanguageStore.getActives().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    this.props.templateStore.getActive().then(() => {
                        this.props.SingleListStore.getData(menuID, languageID).then(() => {
                            if (this.props.SingleListStore.items.length === 0) {
                                confirmAlert('', 'There is no item on this menu', [
                                    {
                                        text: 'OK'
                                    }
                                ]);
                                this.props.history.push('/');
                            } else {
                                const { menu } = this.props.SingleListStore;

                                if (menu) {
                                    if (menu.menuType) {
                                        this.props.popupStore.getByModuleName(menu.menuType).then(resp => {
                                            const { activeTemplate } = this.props.templateStore;

                                            if (activeTemplate) {
                                                if (resp) {
                                                    if (resp.title) {
                                                        confirmAlert(
                                                            <div style={{
                                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                color: activeTemplate.templateSetting.label.color,
                                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                            }}>
                                                                <span>{resp.title}</span>
                                                            </div>,
                                                            <div style={{
                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                color: activeTemplate.templateSetting.text.color,
                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                                                            }}>
                                                                <Markup content={resp.description} />
                                                            </div>,
                                                            [
                                                                {
                                                                    text: <span style={{
                                                                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                        color: activeTemplate.templateSetting.label.color,
                                                                        fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                    }}>OK</span>
                                                                }
                                                            ]);
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        });
                    });
                });
            });
        } else {
            this.props.history.push('/');
        }

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentWillUnmount() {
        this.props.SingleListStore.resetData();
    }

    selectItem = (taskId, isSelected) => {
        this.props.SingleListStore.setisSelected(taskId, isSelected);
    }

    next = () => {
        const { menu, items } = this.props.SingleListStore;

        const item = items.find(x => x.isSelected === true);
        if (item !== undefined) {
            this.props.history.push(`/single-list-confirm/${menu.taskId}/language/${this.props.match.params.languageID}/item/${item.taskId}`);
        }
    }

    back = () => {
        this.props.history.push('/')
    }

    isSelected = () => {
        const { items } = this.props.SingleListStore;

        const item = items.find(x => x.isSelected === true);
        if (item !== undefined) {
            return true;
        }

        return false;
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const hasSelected = this.isSelected();

        const { data: webSettting } = this.props.webSettingStore;

        const {
            menu,
            items
        } = this.props.SingleListStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-layout'>
                                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                {
                                    webSettting
                                        ?
                                        <>
                                            <Content>
                                                {/* Header */}
                                                <>
                                                    <Row>
                                                        <Col
                                                            span={24}
                                                            className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                                background: activeTemplate.templateSetting.header.backgroundColor,
                                                                color: activeTemplate.templateSetting.header.color,
                                                                fontSize: activeTemplate.templateSetting.header.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                            }}
                                                        >
                                                            <Row>
                                                                <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                    <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                                </Col>
                                                                <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                    {menu ? menu.taskName : ''}
                                                                </Col>
                                                                <Col span={4} />
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </>

                                                {/* Banner */}
                                                <>
                                                    {
                                                        menu
                                                            ?
                                                            <>
                                                                {
                                                                    menu.bannerUrl === null || menu.bannerUrl === ''
                                                                        ?
                                                                        <Row className='stm-margin-top-50' />
                                                                        :
                                                                        <>
                                                                            <Row className='stm-height-160 stm-margin-top-50 stm-background-size-100-percent'>
                                                                                <Col span={24} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-160 stm-overflow-hidden'>
                                                                                    <img className='stm-max-width-100-percent' src={menu.bannerUrl} alt='Icon' />
                                                                                </Col>
                                                                            </Row>
                                                                        </>
                                                                }
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </>

                                                {/* Body */}
                                                <>
                                                    <Row className='stm-margin-top-10 stm-background-white'>
                                                        <Col span={1} />
                                                        <Col span={22} className='stm-padding-bottom-100'>
                                                            {/* Description */}
                                                            <>
                                                                {
                                                                    menu
                                                                        ?
                                                                        <>
                                                                            {
                                                                                menu.taskDesc === ''
                                                                                    ?
                                                                                    null
                                                                                    :
                                                                                    <Row className='stm-tab-description-container'>
                                                                                        <Col span={24} className='stm-tab-description'>
                                                                                            <Row>
                                                                                                <Col span={3} className='stm-tab-description-image'>
                                                                                                    <img src={require('../../assets/image/Icon/HelpInfo.svg')} alt='HelpInfo' className='stm-item-desc-image' />
                                                                                                </Col>
                                                                                                <Col
                                                                                                    span={21}
                                                                                                    className='stm-tab-description-text'
                                                                                                    style={{
                                                                                                        fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                        fontSize: activeTemplate.templateSetting.buttonItem.fontSize - 2,
                                                                                                        lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize}px`,
                                                                                                        color: activeTemplate.templateSetting.buttonItem.color
                                                                                                    }}
                                                                                                >
                                                                                                    <Markup content={menu.taskDesc} />
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Col>
                                                                                    </Row>
                                                                            }
                                                                        </>
                                                                        :
                                                                        null
                                                                }
                                                            </>

                                                            {/* List */}
                                                            <>
                                                                <Row>
                                                                    {
                                                                        items.map(item => {
                                                                            return (
                                                                                <>
                                                                                    {
                                                                                        (item.minimumStock > 0 && item.total === 0) || (!item.isAvailable)
                                                                                            ?
                                                                                            <Col
                                                                                                span={24}
                                                                                                className='stm-margin-bottom-10 stm-margin-top-10 stm-padding-16 stm-text-align-center stm-border-radius-4'
                                                                                                onClick={() => this.selectItem(item.taskId, false)}
                                                                                                style={{
                                                                                                    fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                    fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                                                    lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                                                    color: activeTemplate.templateSetting.buttonItem.color,
                                                                                                    border: `1px solid #F5222D`,
                                                                                                    backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                                                                }}
                                                                                            >
                                                                                                {item.taskName}
                                                                                                <div className='stm-single-list-div-outofstock'>
                                                                                                    <span>{webSettting.notAvailableText}</span>
                                                                                                </div>
                                                                                            </Col>
                                                                                            :
                                                                                            <React.Fragment key={item.taskId}>
                                                                                                {
                                                                                                    item.isSelected ?
                                                                                                        <Col
                                                                                                            span={24}
                                                                                                            className='stm-margin-bottom-10 stm-margin-top-10 stm-padding-16 stm-text-align-center stm-border-radius-4'
                                                                                                            onClick={() => this.selectItem(item.taskId, false)}
                                                                                                            style={{
                                                                                                                fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                                                                lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                                                                color: activeTemplate.templateSetting.buttonItemSelected.color,
                                                                                                                border: `1px solid ${activeTemplate.templateSetting.buttonItemSelected.borderColor}`,
                                                                                                                backgroundColor: activeTemplate.templateSetting.buttonItemSelected.backgroundColor
                                                                                                            }}
                                                                                                        >
                                                                                                            {item.taskName}
                                                                                                        </Col>
                                                                                                        :
                                                                                                        <Col
                                                                                                            span={24}
                                                                                                            className='stm-margin-bottom-10 stm-margin-top-10 stm-padding-16 stm-text-align-center stm-border-radius-4'
                                                                                                            onClick={() => this.selectItem(item.taskId, true)}
                                                                                                            style={{
                                                                                                                fontFamily: activeTemplate.templateSetting.buttonItem.fontFamily,
                                                                                                                fontSize: activeTemplate.templateSetting.buttonItem.fontSize,
                                                                                                                lineHeight: `${activeTemplate.templateSetting.buttonItem.fontSize + 2}px`,
                                                                                                                color: activeTemplate.templateSetting.buttonItem.color,
                                                                                                                border: `1px solid ${activeTemplate.templateSetting.buttonItem.borderColor}`,
                                                                                                                backgroundColor: activeTemplate.templateSetting.buttonItem.backgroundColor
                                                                                                            }}
                                                                                                        >
                                                                                                            {item.taskName}
                                                                                                        </Col>
                                                                                                }
                                                                                            </React.Fragment>
                                                                                    }
                                                                                </>
                                                                            )
                                                                        })}
                                                                </Row>
                                                            </>
                                                        </Col>
                                                        <Col span={1} />
                                                    </Row>
                                                </>

                                                {/* Footer */}
                                                <>
                                                    {
                                                        items.length > 0
                                                            ?
                                                            <>
                                                                <Row>
                                                                    <Col
                                                                        span={24}
                                                                        className='stm-position-fixed stm-bottom-0 stm-padding-bottom-15 stm-background-white stm-padding-top-15 stm-max-width-500'
                                                                    >
                                                                        <Row>
                                                                            <Col span={1} />
                                                                            <Col
                                                                                span={22}
                                                                            >
                                                                                <Button
                                                                                    className={hasSelected ? 'stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2' : 'stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2 stm-opacity-60'}
                                                                                    onClick={hasSelected ? this.next : null}
                                                                                    style={{
                                                                                        background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                                                        fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                                                        fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                                                        lineHeight: `${activeTemplate.templateSetting.buttonFooter.fontSize + 2}px`,
                                                                                        color: activeTemplate.templateSetting.buttonFooter.color
                                                                                    }}
                                                                                >
                                                                                    {webSettting.orderText}
                                                                                </Button>
                                                                            </Col>
                                                                            <Col span={1} />
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                            :
                                                            <>
                                                                <Row>
                                                                    <Col span={24} className='stm-margin-top-150 stm-text-align-center'>
                                                                        <Spin
                                                                            spinning={true}
                                                                            tip={webSettting.loadingDataText}
                                                                            style={{
                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                color: activeTemplate.templateSetting.text.color,
                                                                                fontSize: activeTemplate.templateSetting.text.fontSize
                                                                            }}>
                                                                        </Spin>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                    }
                                                </>
                                            </Content>
                                        </>
                                        :
                                        null
                                }
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(SingleListMain);